// Bluetooth Low Energy, one service per provider role.
//
// Distinct from the `bluetooth` capability in the sibling directory, which speaks to the older
// standalone Bluetooth plugin and exposes classic pairing, serial communication and a smaller
// low-energy vocabulary. New work belongs here.
import { BluetoothLowEnergyAdapterService } from './BluetoothLowEnergyAdapterService';
import { BluetoothLowEnergyCentralService } from './BluetoothLowEnergyCentralService';
import { BluetoothLowEnergyPeripheralService } from './BluetoothLowEnergyPeripheralService';

// Event channel types, so a consumer can type its handler.
import { IBluetoothLowEnergyEvent, IBluetoothLowEnergyEventSubscription } from './BluetoothLowEnergyEventChannel';

import { BluetoothLowEnergyNamespace, BluetoothLowEnergyNamespaces } from './adapter/AbstractBluetoothLowEnergyAdapter';

export {
    BluetoothLowEnergyAdapterService,
    BluetoothLowEnergyCentralService,
    BluetoothLowEnergyNamespace,
    BluetoothLowEnergyNamespaces,
    BluetoothLowEnergyPeripheralService,
    IBluetoothLowEnergyEvent,
    IBluetoothLowEnergyEventSubscription,
};
